import BezierEasing from 'bezier-easing';


export default class GradientTransition {
    constructor (cb) {
        this.parent = document.body;
        this.gradients = [];
        this.startTime = 0;
        this.reversing = false;
        this.percentPerFrame = 1;
        this.maxTiming = 0;
        this.cb = cb;

        this.easing = BezierEasing(.6, 0, 0, 1);
    }

    startAnimation () {
        this.buildCanvas();
        this.placeCanvas();
        this.lockWindow(true);
        this.createGradients();
        this.setTransitioning(true);

        this.startRender();
    }

    endAnimation () {
        this.setTransitioning(false);
        this.lockWindow(false);
        //
        // document.querySelector('.background--overview').style.display = 'none';
        // let store = document.querySelector('.background--overview').offsetHeight;
        // window.setTimeout(() => {
        //     document.querySelector('.background--overview').style.display = 'flex';
        // }, 10);

        this.endRender();
    }

    setTransitioning (on) {
        if (on) {
            this.parent.classList.add('transitioning');
        } else {
            this.parent.classList.remove('transitioning');
        }
    }

    buildCanvas () {
        this.canvas = document.createElement('canvas');
        this.canvas.classList.add('gradient-transition');
        this.canvas.width = window.innerWidth;
        this.canvas.height = window.innerHeight;
        this.context = this.canvas.getContext('2d');
    }

    removeCanvas () {
        this.canvas.parentNode && this.canvas.parentNode.removeChild(this.canvas);
    }

    placeCanvas () {
        this.parent.appendChild(this.canvas);
    }

    lockWindow (lock = false) {
        if (lock) {
            document.documentElement.classList.add('is-inactive');
        } else {
            document.documentElement.classList.remove('is-inactive');
        }
    }

    createGradients () {
        // this.addGradient(0, 0, 200, '247, 248, 247', 1000, 600, true);
        this.addGradient(10, 15, 55, '207, 50, 131', 700, 0); //pink
        // this.addGradient(25, 15, 25, '161, 110, 148', 700, 200); //purple
        this.addGradient(110, 60, 50, '174, 214, 241', 700, 400); //blue
        this.addGradient(20, 80, 45, '212, 185, 159', 700, 300); //orange
        this.addGradient(65, -10, 30, '245, 238, 204', 700, 500); //yellow
    }

    addGradient (x, y, endRadius, color, ms, delay, solid = false) {
        this.gradients.push({
            color,
            delay,
            x: x * (window.innerWidth / 100),
            y: y * (window.innerHeight / 100),
            ms,
            solid,
            currentRadius: 0,
            endRadius: endRadius * (window.innerWidth / 100),
        });

        this.maxTiming = Math.max(ms + delay, this.maxTiming);
    }

    startRender () {
        this.setStartTime();

        window.requestAnimationFrame(this.render.bind(this));
    }

    setStartTime () {
        let time = new Date();

        this.startTime = time.getTime();
    }

    endRender () {
        this.setStartTime();
        this.reversing = true;

        window.requestAnimationFrame(this.renderReverse.bind(this));
    }

    renderReverse () {
        this.clearCanvas();

        this.gradients.forEach(this.renderGradient.bind(this));

        if (this.getElapsedTime() >= this.maxTiming) {
            this.removeCanvas();
        } else {
            window.requestAnimationFrame(this.renderReverse.bind(this));
        }
    }

    render () {
        this.clearCanvas();

        this.gradients.forEach(this.renderGradient.bind(this));

        if (this.getElapsedTime() >= this.maxTiming) {
            this.cb && this.cb();
            this.cb = undefined;
        } else {
            window.requestAnimationFrame(this.render.bind(this));
        }
    }

    clearCanvas () {
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }

    renderGradient (gradient) {
        if (this.getElapsedTime() < gradient.delay && !this.reversing) {
            return;
        }

        gradient.currentRadius = this.getRadius(gradient);

        let g = this.context.createRadialGradient(gradient.x, gradient.y, gradient.currentRadius, gradient.x, gradient.y, 0);

        g.addColorStop(0, `rgba(${gradient.color}, 0)`);
        g.addColorStop(0.5, `rgba(${gradient.color}, ${gradient.solid ? '1' : '0.5'})`);
        g.addColorStop(1, `rgba(${gradient.color}, 1)`);

        this.context.fillStyle = g;
        this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
    }

    getRadius (gradient) {
        let timePercentage = Math.min((this.getElapsedTime() - gradient.delay) / gradient.ms, 1);
        timePercentage = this.reversing ? 1 - timePercentage : timePercentage;

        return this.easing(timePercentage) * gradient.endRadius;
    }

    getElapsedTime () {
        let time = new Date();

        return time - this.startTime;
    }
}



// WEBPACK FOOTER //
// ./lib/gradient-transition.js